export const cardData = [
  {
    title: 'maison & déco',
    sousFamille: [
      {
        nom: 'luminaire',iconName:'LightOutlinedIcon',
        sousFamilles: [
          { nom: 'suspensions luminaires', sousSousFamilles: [] },
          { nom: 'plafonniers et lampes plafond', sousSousFamilles: [] },
          { nom: 'lampes de table', sousSousFamilles: [] },
          { nom: 'spots', sousSousFamilles: [] },
          { nom: 'ampoules', sousSousFamilles: [] },
          { nom: 'spots encastrables', sousSousFamilles: [] },
        ]
      },
      {
        nom: 'meubles',iconName:'TableRestaurantOutlinedIcon',
        sousFamilles: []
      }
    ]
  },

  {
    title: 'électroménager & cuisine',
    sousFamille: [
      {
        nom: 'cuisine',iconName:'BlenderOutlinedIcon',
        sousFamilles: [
          { nom: 'preparation culinaire', sousSousFamilles: [] },
          { nom: 'appareil de cuission', sousSousFamilles: [] },
          { nom: 'cafe et petit dejeuner', sousSousFamilles: [] },
          { nom: 'glaciere', sousSousFamilles: [] },
        ]
      },
      {
        nom: 'maison',iconName:'CottageOutlinedIcon',
        sousFamilles: []
      }
    ]
  },

  {
    title: 'informatique & lifestyle',
    sousFamille: [
      {
        nom: 'informatique',iconName:'LaptopMacOutlinedIcon',
        sousFamilles: [
          { nom: 'souris', sousSousFamilles: [] },
          { nom: 'casque', sousSousFamilles: [] },
          { nom: 'enceinte & radio reveil', sousSousFamilles: [] },
          { nom: 'accessoire', sousSousFamilles: [] },
          { nom: 'cable', sousSousFamilles: [] },
          { nom: 'cle usb', sousSousFamilles: [] },
          { nom: 'lecteur de carte et micro SD', sousSousFamilles: [] },
        ]
      },
      {
        nom: 'lifestyle',iconName:'WatchOutlinedIcon',
        sousFamilles: [
          {
            nom: 'accessoires',
            sousSousFamilles: [
              'enfant',
              'homme',
              'femme'
            ]
          },
          {
            nom: 'beaute & sante',
            sousSousFamilles: [
              'bien être',
              'coiffure',
              'epilation',
              'rasoir et tendeuse',
              'soin visage et corps'
            ]
          }
        ]
      },
    ]
  },



  {
    title: "tout à -100 dt",
    sousFamille: []
  }
];
